<template>
    <section v-if="loaded && payments.length" class="event-invoices">
        <h2 class="event-invoices__title">{{ title }}</h2>
        <ul class="event-invoices__list">
            <li
                v-for="payment in payments"
                :key="payment.id"
                class="event-invoices__item"
            >
                <div class="event-invoices__meta">
                    <p class="event-invoices__name">{{ payment.name || eventName }}</p>
                    <p class="event-invoices__amount">{{ payment.amount }} zł</p>
                </div>
                <button
                    class="event-invoices__download"
                    type="button"
                    :disabled="downloadingId === payment.id"
                    @click="downloadInvoice(payment.id)"
                >
                    {{ downloadingId === payment.id ? 'Pobieranie…' : 'Pobierz fakturę' }}
                </button>
            </li>
        </ul>
        <notifications group="foo"/>
    </section>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: 'Faktury',
        },
    },

    data() {
        return {
            loaded: false,
            payments: [],
            eventName: '',
            downloadingId: null,
        };
    },

    created() {
        this.fetchInvoices();
    },

    methods: {
        fetchInvoices() {
            axios.get('/api/user-data/event-invoices')
                .then((response) => {
                    const data = response.data?.data || {};
                    this.payments = data.payments || [];
                    this.eventName = data.event_name || '';
                })
                .catch(() => {
                    this.payments = [];
                })
                .finally(() => {
                    this.loaded = true;
                });
        },

        downloadInvoice(paymentId) {
            this.downloadingId = paymentId;
            axios({
                url: `/api/user-data/${paymentId}/get-invoice`,
                method: 'GET',
                responseType: 'blob',
            })
                .then(async (response) => {
                    const contentType = response.headers['content-type'] || '';
                    if (contentType.includes('application/json')) {
                        const text = await response.data.text();
                        let message = 'Nie udało się pobrać faktury.';
                        try {
                            message = JSON.parse(text).message || message;
                        } catch (e) {
                            // keep default
                        }
                        throw new Error(message);
                    }

                    const fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                    const fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'faktura.pdf');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    fileLink.remove();
                    window.URL.revokeObjectURL(fileURL);

                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'Faktura została pobrana pomyślnie',
                    });
                })
                .catch(async (error) => {
                    let message = 'Nie udało się pobrać faktury.';
                    if (error?.message && error.message !== 'Network Error') {
                        message = error.message;
                    }
                    const data = error?.response?.data;
                    if (data instanceof Blob) {
                        try {
                            const parsed = JSON.parse(await data.text());
                            if (parsed.message) {
                                message = parsed.message;
                            }
                        } catch (e) {
                            // keep default
                        }
                    } else if (typeof data?.message === 'string') {
                        message = data.message;
                    }
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: message,
                    });
                })
                .finally(() => {
                    this.downloadingId = null;
                });
        },
    },
};
</script>
